import React from 'react'

import Tooltip from '~/components/tooltip'
import { usePageContext } from '~/contexts/page-context'

import styles from './styles.module.css'

const Sort = ({ order, onChangeOrder }) => {
  const { orderings } = usePageContext()

  return (
    <div className={styles.facets}>
      {orderings.map((o) => (
        <div key={o.sortKey} className={styles.container}>
          <label className={styles.facet}>
            <input
              type='radio'
              value={o.sortKey}
              name='sort-by'
              defaultChecked={o.sortKey === order}
              onChange={onChangeOrder}
            />
            <span className={styles.radio}></span>
            <div className={styles.labelContainer}>
              <div className={styles.name}>{o.description}</div>
            </div>
          </label>

          {!!o.tooltip && <Tooltip content={o.tooltip} wrapperStyles={styles.tooltipWrapper} />}
        </div>
      ))}
    </div>
  )
}

export default Sort
